// 合同模块

export default {
  namespaced: true,
  state() {
    return {
      // 合同信息
      profile: {
        list: [],
        form: {},
      },
    };
  },
  mutations: {
    // 添加合同信息，payload就是传过来的合同信息对象
    setContract(state, payload) {
      state.profile.list.unshift({ ...payload, id: state.profile.list.length });
    },
    setClearContract(state, payload) {
      let data = state.profile.list.filter((v) => v.id == payload.id);
      state.profile.list.splice([state.profile.list.indexOf(...data)], 1);
    },
    setEditContract(state, payload) {
      let data = state.profile.list.filter((v) => v.id == payload.id);
      state.profile.list.splice(
        [state.profile.list.indexOf(...data)],
        1,
        payload
      );
    },
    // 临时存储
    setContractForm(state, payload) {
      state.profile.form = payload;
    },
  },
};
